const jumpMap = {
};

import { native } from '@ali/amap-lib';
import { EventBus } from './event-bus';

/**
 * 跳转链接处理，带有点击锁定
 * @param {string} URI - 跳转的链接，默认为 500ms
 * @param {Object} config - 定制化参数
 * @property {boolean} [config.needSchema=false]  - 是否强制schema转换，默认 false 不转换
 * @property {number} [config.delay=0] - 跳转延迟
 * @property {boolean} [config.hideTitleBar=false] - 是否隐藏 titleBar，需要 needSchema 开启
 */
const jumpHandler = (URI, config =
  {
    needSchema: false,
    delay: 0,
    hideTitleBar: false,
  }) => {
  let isJump = jumpMap[URI] === true || Object.keys(jumpMap).some(key => jumpMap[key] === true);
  if (isJump) {
    return false;
  }

  const {
    needSchema,
    delay,
    hideTitleBar
  } = config;

  jumpMap[URI] = true;

  setTimeout(() => {
    Object.keys(jumpMap).forEach(key => jumpMap[key] = false);
  }, 500);

  EventBus.$emit('jumpHandler.jump');

  const isSchema = /^(?:(?:ios|android)amap|amapuri|schema|alipays):\/\//i.test(URI);
  if (isSchema) { // scheme

    setTimeout(() => {
      native.loadSchema(URI);
    }, delay)
  }
  if (!isSchema && needSchema) { // http 强制转 schema
    setTimeout(() => {
      const url = `amapuri://webview/amaponline?url=${encodeURIComponent(URI)}&hide_title=${hideTitleBar ? 1 : 0}`;
      native.loadSchema(url);
    }, delay);
  }
  if (!isSchema && !needSchema) { // http
    setTimeout(() => {
      window.location.href = decodeURIComponent(URI);
    }, delay)
  }
};

export default jumpHandler;